import SearchAddUserView from '@/views/kpi/enterprise/my-org-user-list/search-add-user-view.vue';
export const useOpenSearchUserModal = () => {
  const {
    openEditor
  } = useComponentModal();
  const openSearchUserModal = async () => {
    const res = await openEditor('添加用户', SearchAddUserView, {}, {
      width: '70%',
      height: '400px',
      fullscreen: false,
      showMaximize: false,
      showMinimize: false
    });
    return Promise.resolve(res);
  };
  return {
    openSearchUserModal
  };
};